"use strict";

exports.__esModule = true;
var _AuditLogContext = require("./AuditLogContext");
Object.keys(_AuditLogContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AuditLogContext[key]) return;
  exports[key] = _AuditLogContext[key];
});
var _AuditLogController = require("./AuditLogController");
Object.keys(_AuditLogController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AuditLogController[key]) return;
  exports[key] = _AuditLogController[key];
});